import { render, staticRenderFns } from "./new_media_monitoring.vue?vue&type=template&id=8474a9ae&scoped=true&"
import script from "./new_media_monitoring.vue?vue&type=script&lang=js&"
export * from "./new_media_monitoring.vue?vue&type=script&lang=js&"
import style0 from "./new_media_monitoring.vue?vue&type=style&index=0&id=8474a9ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8474a9ae",
  null
  
)

export default component.exports